import { render } from "./nav-bar.vue?vue&type=template&id=ed2beaca&scoped=true&lang=html"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=ed2beaca&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\unistroy\\market\\market-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2beaca"]])

export default __exports__